import LoginLogout from "./LoginLogout"
export default function TimeTracking()
{
    return(
        <div>
            <LoginLogout />
        </div>
    )
}